import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
  mode: 'hash', // 使用HTML5 History模式
  routes: [
      // 默认路由，路由重定向
      {
          path: '/',
          redirect: '/workbench'
      },
      // 登录页路由
      {
          path: '/login',
          name: 'PageLogin',
          component: ()=>import('@/views/login/index.vue')
      },
      {
          // 工作台模块
          path: '/workbench',
          name: 'Workbench',
          component: () => import('@/views/workbench/index.vue'),
          meta: {
              title: '工作台',
          },
          redirect: '/home',
          children: [
              // 工作台-首页
              {
                  path: '/home',
                  name: 'Home',
                  component: () => import('@/views/workbench/home/index.vue'),
                  meta: {
                      parent:{
                          path: '/product'
                      }
                  }
              },
              // 工作台-产品
              {
                  path: '/product',
                  name: 'Product',
                  component: () => import('@/views/workbench/product/index.vue'),
                  redirect: '/product/tool',
                  meta: {
                      parent:{
                          path: '/product'
                      }
                  },
                  children: [
                      // 工作台-产品-工具app
                      {
                          path: '/product/tool',
                          name: 'Tool',
                          component: () => import('@/views/workbench/product/tool/index.vue')
                      },
                      // 工作台-产品-网赚app
                      {
                          path: '/product/wz',
                          name: 'Wz',
                          component: () => import('@/views/workbench/product/wz/index.vue')
                      },
                      // 工作台-产品-小程序app
                      {
                          path: '/product/mini',
                          name: 'Mini',
                          component: () => import('@/views/workbench/product/mini/index.vue')
                      }
                  ]
              },
              // 工作台-分析
              {
                  path: '/analysis',
                  name: 'Analysis',
                  component: () => import('@/views/workbench/analysis/index.vue'),
                  redirect: '/analysis/guide',
                  meta: {
                      parent:{
                          path: '/analysis'
                      }
                  },
                  children: [
                      // 工作台-分析-分析引导
                      {
                          path: '/analysis/guide',
                          name: 'Tool',
                          component: () => import('@/views/workbench/analysis/guide/index.vue')
                      },
                      // 工作台-分析-ECPM上报
                      {
                          path: '/analysis/ecpm',
                          name: 'Tool',
                          component: () => import('@/views/workbench/analysis/ECPM/index.vue')
                      }
                  ]
              },
              // 工作台-事件
              {
                  path: '/event',
                  name: 'Event',
                  component: () => import('@/views/workbench/event/index.vue'),
                  redirect: '/event/blackInfo',
                  meta: {
                      parent:{
                          path: '/event'
                      }
                  },
                  children: [
                      // 工作台-事件-黑名单
                      {
                          path: '/event/blackInfo',
                          name: 'BlackInfo',
                          component: () => import('@/views/workbench/event/blackInfo/index.vue')
                      },
                      // 工作台-事件-白名单
                      {
                          path: '/event/whiteInfo',
                          name: 'WhiteInfo',
                          component: () => import('@/views/workbench/event/whiteInfo/index.vue')
                      }
                  ]
              }
          ]
      },
      {
          path: '/wzReport',
          name: 'WzReport',
          component: ()=>import('@/views/wzReport/index.vue'),
          meta: {
              title: '网赚运营报告',
          },

      }
  ]
});
